module.exports = __webpack_public_path__ + "static/img/pic_kongde.c21661f7.png";